import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import React from 'react';
import ReactDOM from 'react-dom';
import { GlueDefaultRouteObject } from './routing';
import { EventManager, mergeGlueRouteObjectArrays } from './utils';
import { createBrowserHistory } from 'history';
import { Api } from './api/Api';
import Smartfire, { defineBlock } from '@smartfire/gutenberg-react';
import { triggerGlueReady } from './glue-on-ready';
export var BlockApi = Smartfire; // import type {SmartBlockSmartPropsDefinition, SmartProps} from "@smartfire/gutenberg-react"
// import type {DefineBlockProp} from "@smartfire/gutenberg-react/lib/defineBlock";

export var GlueEvents;

(function (GlueEvents) {
  /**
   * Authentication module has been setup and can be used.
   */
  GlueEvents["AUTHENTICATION_SETUP"] = "[authentication] setup";
  /**
   * A specific rendering is requested NOW (e.g. login UI)
   */

  GlueEvents["ROUTING_OVERRIDE"] = "[routing] override current route";
  GlueEvents["ROUTING_REFRESH"] = "[routing] refresh";
  GlueEvents["COMPONENTS_REFRESH"] = "[components] refresh";
  GlueEvents["SETTING_REFRESH"] = "[setting] refresh"; // Base string for addFilter event

  GlueEvents["ADD_FILTER_PREFIX"] = "[filters]";
})(GlueEvents || (GlueEvents = {}));

function getPriorityLevel(a) {
  return a.priority === undefined ? Infinity : a.priority;
}

export var GlueAPI = /*#__PURE__*/function () {
  function GlueAPI() {
    var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';

    _classCallCheck(this, GlueAPI);

    this.host = host;
    this.eventsManager = new EventManager();
    this._features = {
      frontTranslation: false,
      editingTranslation: false,
      smartForm: false,
      multiWebsite: false
    };
    this._frontLanguages = ['fr'];
    this._editingLanguages = ['fr'];
    this._components = [];
    this.filters = {};
    this._websites = [{
      name: 'Default website',
      code: 'default',
      bodyClass: 'default'
    }];
    this._layouts = [];
    this._routes = GlueDefaultRouteObject;
    this._settings = [];
    this._browserHistory = createBrowserHistory();
  }

  _createClass(GlueAPI, [{
    key: "authentication",
    get: function get() {
      return this._authentication;
    },
    set: function set(value) {
      this._authentication = value;
      this.eventsManager.fire(GlueEvents.AUTHENTICATION_SETUP, value);
    }
  }, {
    key: "websites",
    get: function get() {
      return this._websites;
    }
  }, {
    key: "layouts",
    get: function get() {
      return this._layouts;
    }
  }, {
    key: "routes",
    get: function get() {
      return this._routes;
    }
  }, {
    key: "settings",
    get: function get() {
      return this._settings;
    }
  }, {
    key: "browserHistory",
    get: function get() {
      return this._browserHistory;
    }
  }, {
    key: "api",
    get: function get() {
      if (!this._api) {
        this._api = new Api(this);
      }

      return this._api;
    }
  }, {
    key: "frontAvailableLanguages",
    get: function get() {
      return this._frontLanguages;
    }
  }, {
    key: "editingAvailableLanguages",
    get: function get() {
      return this._editingLanguages;
    }
  }, {
    key: "isSmartFormEnabled",
    value: function isSmartFormEnabled() {
      return this._features.smartForm;
    }
  }, {
    key: "isFrontTranslationEnabled",
    value: function isFrontTranslationEnabled() {
      return this._features.frontTranslation;
    }
  }, {
    key: "isFrontEditingEnabled",
    value: function isFrontEditingEnabled() {
      return this._features.editingTranslation;
    }
  }, {
    key: "isMultiWebsite",
    value: function isMultiWebsite() {
      return this._features.multiWebsite;
    }
  }, {
    key: "websiteFromCode",
    value: function websiteFromCode(code) {
      return this._websites.find(function (e) {
        return e.code === code;
      });
    }
  }, {
    key: "setWebsites",
    value: function setWebsites(websites) {
      this._features.multiWebsite = websites.length > 1;
      this._websites = websites;
    }
  }, {
    key: "setFrontAvailableTranslations",
    value: function setFrontAvailableTranslations(languages) {
      this._features.frontTranslation = languages.length > 1;
      this._frontLanguages = languages;
    }
  }, {
    key: "setEditingAvailableTranslations",
    value: function setEditingAvailableTranslations(languages) {
      this._features.editingTranslation = languages.length > 1;
      this._editingLanguages = languages;
    }
  }, {
    key: "setSmartFormStatus",
    value: function setSmartFormStatus(status) {
      this._features.smartForm = status;
    }
  }, {
    key: "on",
    value: function on(e, callback) {
      return this.eventsManager.addListener(e, callback);
    }
  }, {
    key: "renderDOM",
    value: function renderDOM() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        rootElementId: 'root'
      },
          _ref$wrapper = _ref.wrapper,
          Wrapper = _ref$wrapper === void 0 ? undefined : _ref$wrapper,
          _ref$rootElementId = _ref.rootElementId,
          rootElementId = _ref$rootElementId === void 0 ? 'root' : _ref$rootElementId;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var promisedComponents, module, GlueUI;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(window['smartfire'] && window['smartfire'].components)) {
                  _context.next = 5;
                  break;
                }

                promisedComponents = Object.values(window['smartfire'].components).map(function (block) {
                  return block();
                });

                if (!(promisedComponents.length > 0)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return Promise.all(promisedComponents);

              case 5:
                _context.next = 7;
                return import('./ui/GlueUI');

              case 7:
                module = _context.sent;
                GlueUI = module.GlueUI;
                ReactDOM.render(Wrapper ? React.createElement(Wrapper, null, React.createElement(GlueUI, null)) : React.createElement(GlueUI, null), document.getElementById(rootElementId));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }, {
    key: "setRoutes",
    value: function setRoutes(routes) {
      this._routes = routes;
      this.eventsManager.fire(GlueEvents.ROUTING_REFRESH, this);
      return this._routes;
    }
  }, {
    key: "addRoutes",
    value: function addRoutes(routes) {
      return this.setRoutes(mergeGlueRouteObjectArrays(this._routes, routes));
    }
  }, {
    key: "registerSetting",
    value: function registerSetting(setting) {
      if (this._settings.some(function (element) {
        return element.key === setting.key;
      })) throw 'Setting key already exists';

      this._settings.push(setting);

      this.eventsManager.fire(GlueEvents.SETTING_REFRESH, this);
      return setting;
    }
  }, {
    key: "registerLayout",
    value: function registerLayout(layout) {
      this._layouts.push(layout);

      return layout;
    }
  }, {
    key: "getLayoutFor",
    value: function getLayoutFor(type) {
      return this._layouts.filter(function (element) {
        var _a;

        return (_a = element.availableFor) === null || _a === void 0 ? void 0 : _a.includes(type);
      });
    } // registerBlock<
    //     SmartPropsForBlock extends SmartBlockSmartPropsDefinition = {[k: string]: SmartProps},
    //     ReactProps extends {[k: string]: any} = {[k in keyof SmartPropsForBlock]: any} & {[k: string]: any},
    //     ReactElement extends FunctionComponent<ReactProps> = FunctionComponent<ReactProps>>
    // (name: string, block: DefineBlockProp<SmartPropsForBlock, ReactProps, ReactElement>, vendor = 'smartfire') {
    //     BlockApi.registerBlock<SmartPropsForBlock, ReactProps, ReactElement>(name, () => Promise.resolve(defineBlock<SmartPropsForBlock, ReactProps, ReactElement>(block)), vendor);
    //     return block;
    // }

  }, {
    key: "registerComponent",
    value: function registerComponent(component) {
      if (component.priority === undefined) {
        component.priority = Infinity;
      }

      this._components.push(component);

      this.eventsManager.fire(GlueEvents.COMPONENTS_REFRESH, this);
      return component;
    }
  }, {
    key: "registerBlock",
    value: function registerBlock(name, block) {
      var vendor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'smartfire';
      BlockApi.registerBlock(name, function () {
        return Promise.resolve(defineBlock(block));
      }, vendor);
      return block;
    }
  }, {
    key: "getComponent",
    value: function getComponent(kind) {
      var candidates = this._components.filter(function (c) {
        return c.kind === kind;
      }).sort(function (a, b) {
        return getPriorityLevel(a) - getPriorityLevel(b);
      });

      if (candidates.length < 1) {
        return undefined;
      } else {
        return candidates[0].component;
      }
    }
  }, {
    key: "addFilter",
    value: function addFilter(kind, filter) {
      var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

      if (!this.filters[kind]) {
        this.filters[kind] = [];
      }

      this.filters[kind].push({
        filter: filter,
        priority: priority
      });
      this.eventsManager.fire(GlueEvents.ADD_FILTER_PREFIX + kind, this);
    }
  }, {
    key: "applyFilter",
    value: function applyFilter(kind, value) {
      if (!this.filters[kind]) {
        return value;
      }

      this.filters[kind].sort(function (a, b) {
        return a.priority - b.priority;
      }).forEach(function (element) {
        value = element.filter(value);
      });
      return value;
    }
  }]);

  return GlueAPI;
}();
var glue = new GlueAPI();
GlueAPI.Context = React.createContext(glue);
export var setRoutes = glue.setRoutes.bind(glue);
export var addRoutes = glue.addRoutes.bind(glue);
export var registerLayout = glue.registerLayout.bind(glue);
export var registerComponent = glue.registerComponent.bind(glue);
export var registerBlock = glue.registerBlock.bind(glue);
export var registerSetting = glue.registerSetting.bind(glue);
export var getLayoutFor = glue.getLayoutFor.bind(glue);
export * from './hooks';
triggerGlueReady(glue);
export default glue;